import img13a from '../../../assets/gallery/13a/13a-01-HOME_Tablas-&-camas-2013-273x176mm-oleo-sobre-revista-National-Geographic-y-madera.png';
import img13b from '../../../assets/gallery/13a/13a-02_Tablas-&-camas-2013-282x176mm-oleo-sobre-revista-National-Geographic-y-madera.png';
import img13c from '../../../assets/gallery/13a/13a-03_Tablas-&-camas-2013-284x176mm-oleo-sobre-revista-National-Geographic-y-madera.png';
import img13d from '../../../assets/gallery/13a/13a-04_Tablas&camas-2013-27x176mm-oleo-sobre-revista-National-Geographic-y-madera.png';
import img13e from '../../../assets/gallery/13a/13a-04_Tablas-&-camas-2013-27x176mm-oleo-sobre-revista-National-Geographic-y-madera.png';
import img13f from '../../../assets/gallery/13a/13a-05_Tablas-&-camas-2013-285x176mm-oleo-sobre-revista-National-Geographic-y-madera.png';
import img13g from '../../../assets/gallery/13a/13a-06_Tablas-&-camas-2013-273x176mm-oleo-sobre-revista-National-Geographic-y-madera.png';

export const dataImages = [
  {
    id: 1,
    title: "",
    dimensions: "27,3 x 17,6 cm",
    pictureSrc: img13a,
    description: "2013",
    orientation: "v"
  },
  {
    id: 2,
    title: "",
    dimensions: "28,2 x 17,6 cm",
    pictureSrc: img13b,
    description: "2013",
    orientation: "v"
  },
  {
    id: 3,
    title: "",
    dimensions: "28,4 x 17,6 cm",
    pictureSrc: img13c,
    description: "2013",
    orientation: "v"
  },
  {
    id: 4,
    title: "",
    dimensions: "27 x 17,6 cm",
    pictureSrc: img13d,
    description: "2011",
    orientation: "v"
  },
  // {
  //   id: 5,
  //   title: "",
  //   dimensions: "27 x 17,6 cm",
  //   pictureSrc: img13e,
  //   description: "2013",
  //   orientation: "v"
  // },
  {
    id: 6,
    title: "",
    dimensions: "28,5 x 17,6 cm",
    pictureSrc: img13f,
    description: "2013",
    orientation: "v"
  },
  {
    id: 7,
    title: "",
    dimensions: "27,3 x 17,6 cm",
    pictureSrc: img13g,
    description: "2013",
    orientation: "v"
  },
].sort(() => Math.random() - 0.5);

export const dimensionsH = [
  { width: "820" },
  { width: "730" },
  { width: "700" },
  { width: "650" },
  { width: "539" },
  { width: "444" },
  { width: "400" },
  { width: "382" },
];


export const dimensionsV = [
  { width: "820" },
  { width: "730" },
  { width: "700" },
  { width: "650" },
  { width: "539" },
  { width: "444" },
  { width: "400" },
  { width: "382" },
];



// WEBPACK FOOTER //
// ./src/pages/gallery/13a/data13a.js